/* eslint-disable react-hooks/exhaustive-deps */
import React,{useEffect, useState} from 'react';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import BarcodeScanner from 'react-qr-barcode-scanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faCheck, faFaceFrown, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { Input } from '@progress/kendo-react-inputs';


//Scan the participant's ID barcode and report their pending reservations for the active program area

export const ResCheck=({onClose,areaId,checkIn})=>{
    //Lookup the age by AttendeeID
    const [scanValue,setScanValue]=useState("");    
    const [showScanner,setShowScanner]=useState(true);
    const [data,setData]=useState(undefined);
    const [dateStr, setDateStr]=useState("");
    const [timeStr, setTimeStr]=useState("");
    const [checkedIn, setCheckedIn]=useState(false);
    const [today,setToday]=useState(true);
    const [manEntry, setManEntry]=useState("");
    const [manConfirm,setManConfirm]=useState(false);
    const [showManual,setShowManual]=useState(false);
    const [manParticipant,setManParticipant]=useState(undefined);   

    const getRes = async (id)=>{
        console.log(id);
        console.log(areaId);
        const date = new Date();
        const tdy = getToday();
        console.log(tdy);
        const params=new URLSearchParams({id:id, area:areaId, date:tdy});
        const url= "api/index.php/program/getResForDate?" + params;
        fetch (url,{
            method:"GET"
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            setData(data);
        })
    }

    const getToday = ()=>{
        let tdy = new Date();
        const day1 = new Date(2026,6,23);
        if (tdy< day1){
            tdy=new Date(day1);
        }
        const year = ''+tdy.getFullYear();
        let month = ''+(tdy.getMonth()+1);
        let day = ''+tdy.getDate();
        if (month.length<2){
            month = "0" +month;
        }
        if (day.length<2){
            day = "0"+day;
        }
        const dtParam = [year,month,day].join("-");
        return (dtParam);
    }


    const gateScan=()=>{
        console.log("Gate Scan: " + areaId + " " + scanValue);
        const postData = new FormData();
        const url= "api/index.php/program/gateScan";
        postData.append("id",scanValue);
        postData.append("area",areaId);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data.action=="GATE"){
                completeRes(2);
            }
        })
    }

    const stageOneScan=()=>{
        completeRes(1);
    }


    const completeRes=(value)=>{
        console.log("Stage " + value + " Scan: " + areaId + " " + scanValue);
        const postData = new FormData();
        const url= "api/index.php/program/completeReservation";
        postData.append("id",scanValue);
        postData.append("area",areaId);
        postData.append("block",data[0].BlockId);
        postData.append("value",value);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
            if (data>0){
                setCheckedIn(true);
            }
        })
    }


    const onScan=(err,result)=>{
        if (result){
            console.log(result);
            setScanValue(result.text);
            hideScanner();
        }
    }

    const resetScanValue=()=>{
        setScanValue("");
    }

    const openScanner=()=>{
        setData(undefined);
    }
    const resetCheckedIn=()=>{
        setCheckedIn(false);
    }

    const resetScanner=()=>{
        resetScanValue();
        clearData();
        resetCheckedIn();
        setShowScanner(true);
    }

    const clearData=()=>{
        setData(undefined);
    }

    const hideScanner=()=>{
        setShowScanner(false);
    }
    const openManual=()=>{
        console.log("Open Manual");
        clearParticipant();
        setShowManual(true);
    }

    const closeManual=()=>{
        setShowManual(false);
    }

    const clearParticipant=()=>{
        setManParticipant(undefined);
    }


    const ManualEntry=()=>{
            const manualIDChange=(event)=>{
                console.log(event.value);
                setManEntry(event.value);
            }
            const checkManParticipant = async ()=>{
                if (manEntry!=""){
                    const params=new URLSearchParams({id:manEntry, name:""});
                    const url= "api/index.php/program/getParticipant?" + params;
                    fetch (url,{
                        method:"GET"
                    }).then(response=>response.json()).then(async data=> {
                        console.log(data);
                        setManParticipant(data);
                    })
                }
            }
            
            const saveManual=()=>{
                setScanValue(manParticipant[0].MemberId)
                closeManual();
                hideScanner();
                setManEntry("");
            }
    
            return(
                <Dialog className='atol-dlg-error' title={"Enter manual ID"} onClose={closeManual}>
                    <p>Enter the ID number found on your Jamboree ID</p>
                    <Input onChange={manualIDChange} value={manEntry}></Input>
                    {manParticipant?    
                    <>
                    <p>Are you {manParticipant[0].NameFirst} {manParticipant[0].NameLast}?</p>
                    <Button onClick={saveManual}>Yes</Button>
                    <Button onClick={clearParticipant}>No</Button>    
                    </>
                    :null}
                    <DialogActionsBar>
                        {manConfirm?
                            <Button>Save</Button>                
                        :
                            <Button onClick={checkManParticipant}>Check ID</Button>
                        }
    
                    </DialogActionsBar>
                </Dialog>
            )
        }

    useEffect(()=>{
        console.log("CheckIn:");
        console.log(checkIn);
    },[]);

    useEffect(()=>{
        console.log("ScanValue:" + scanValue);
        if (scanValue!==""){
            getRes(scanValue);
        }
    },[scanValue]);

    useEffect(()=>{
        if (data && data.length>0){
            const dt = new Date(data[0].Date + "T" + data[0].StartTime)
            const actDate = dt.toDateString();
            const actTime = dt.toLocaleTimeString([], { timeStyle: 'short' });
            setDateStr(actDate);
            setTimeStr(actTime);
            let today = new Date();
            let day1 = new Date("07/23/2026");
            if (today<day1){
                today=new Date (day1);
            }
            if (new Date(actDate).getDate()!==today.getDate()){
                setToday(false);
            }
        }
    },[data])

    return(
        <Dialog title="Check Reservation" onClose={onClose} width={"90vw"} height={"90vh"}>
            {data?
                <>
                {data.length>0?
                    <div className={"scanResult go"}>
                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceSmile} /></div>
                        <h1>{scanValue}</h1>
                        <h1>{data[0].NameFirst} {data[0].NameLast}</h1>
                        <h3>Reservation for:</h3>
                        <h2>{dateStr}</h2>
                        <h2>{timeStr}</h2>
                        {checkedIn?<div style={{fontSize:"xxx-Large", padding:"10px"}}><FontAwesomeIcon icon={faCheck} /></div>:null}
                        <div><Button size='large' fillMode='outline' style={{color:"white",width:"95%"}} onClick={openScanner}>Scan Again</Button></div>
                        {today?
                            <>
                            {!checkedIn?
                                <>
                                    {checkIn===2?
                                        //two stage gate scan
                                        data[0].Complete===0?<div style={{paddingTop:"20px"}}><Button size='large' fillMode='outline' style={{color:"white",width:"95%"}} onClick={stageOneScan}>Welcome Check-In</Button></div>
                                        :<div style={{paddingTop:"20px"}}><Button size='large' fillMode='outline' style={{color:"white",width:"95%"}} onClick={gateScan}>Check In</Button></div>  
                                    :
                                        //Simple gate scan only.
                                        <div style={{paddingTop:"20px"}}><Button size='large' fillMode='outline' style={{color:"white",width:"95%"}} onClick={gateScan}>Check In</Button></div>
                                    }
                                </>
                                :null}
                            </>
                        :null}
                    </div>
                :
                    <>
                   
                    <div className={"scanResult stop"}>
                        <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceFrown} /></div>
                        <h1>{scanValue}</h1>
                        <h2>No reservation found for:</h2>
                        <h3>{getToday()}</h3>
                        <div><Button size='large' fillMode='outline' style={{color:"white", width:"95%"}} onClick={resetScanner}>Scan Again</Button></div>
                        <div><Button size='large' fillMode='outline' style={{color:"white", width:"95%", marginTop:"10px"}} onClick={onClose}>Close</Button></div>
                    </div>
                    </>}
                </>                
            :
            <>
                <div style={{fontSize:"xxx-Large", textAlign:"center"}}><FontAwesomeIcon icon={faCamera} /></div>
                <p>Use the device camera to scan the barcode found on the Jamboree ID.</p>
                {showScanner?
                <>
                 {showManual?
                        <ManualEntry></ManualEntry>
                    :null}
                <Button onClick={openManual}>Having trouble reading the barcode?</Button>
                <BarcodeScanner height={"50%"}onUpdate={onScan}></BarcodeScanner>
                </>
                :null}
            </>
            }
        </Dialog>
    )

}